export const DATE_FORMAT = 'yyyy.MM.dd';
export const DATE_MONTH_FORMAT = 'yyyy.MM';
export const DATE_HOUR_MINUTE_FORMAT = 'yyyy.MM.dd HH:mm';
export const DATE_HOUR_MINUTE_SECOND_FORMAT = 'yyyy.MM.dd HH:mm:ss';
